/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UserTrackingUsers from "../components/ui/UserTrackingUsers";
import { usePageTitle } from "../hooks/usePageTitle";
import { AppDispatch, RootState } from "../store";
import { fetchAllUserTracking } from "../store/slices/userTrackingSlice";

const UserUsagePage: React.FC = () => {
  usePageTitle("User Usage");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  const { users, usersLoading, usersError, usersPagination } = useSelector(
    (state: RootState) => state.userTracking
  );

  const loadUsageUsers = () =>
    dispatch(
      fetchAllUserTracking({
        page: currentPage,
        limit: 20,
        sortBy: "appUsageStats.averageSessionDuration",
        sortOrder: "desc",
      })
    );

  const handleViewUser = (user: any) => {
    const userId = user?.userId || user?.userId?._id || user?.userInfo?._id;
    if (!userId) return;
    navigate(`/user-profile/${userId}`, { state: { trackingUser: user } });
  };

  useEffect(() => {
    loadUsageUsers();
  }, [currentPage]);

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">User Usage</h1>
          <p className="text-gray-600 mt-1">
            Users sorted by average session duration
          </p>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/user-tracking")}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </button>

          <button
            onClick={loadUsageUsers}
            disabled={usersLoading}
            className="flex items-center gap-2 px-4 py-2 text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Refresh data"
          >
            <RefreshCw
              className={`h-4 w-4 ${usersLoading ? "animate-spin" : ""}`}
            />
            Refresh
          </button>
        </div>
      </div>

      {usersError && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
          <h3 className="text-red-800 font-medium">Error Loading Users</h3>
          <p className="text-red-600 mt-1">{usersError}</p>
        </div>
      )}

      <UserTrackingUsers
        users={users}
        isLoading={usersLoading}
        error={usersError}
        pagination={usersPagination}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        onViewUser={handleViewUser}
        showUsage
      />
    </div>
  );
};

export default UserUsagePage;
